import React, { Component } from "react";
import "../style/panel.css";
import { Link } from "react-router-dom";
import $ from "jquery";
import {getPrivilegeByName} from '../privilegeUtils';
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from "reactstrap";

const data = [];
export default class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.handleLine = this.handleLine.bind(this);
    this.state = {
      opened: []
     
    };
    
  }
  componentDidMount(){
    this.handleLine();
  }

componentWillReceiveProps(){
  this.handleLine();
}

  handleLine(){

    $(function(){
      
      $("#tab1").click(function(){
        $("#section").toggle();
      });
      });

      $(function(){
      $("#c2").click(function(){
        $("#d2").toggle();
      });
      });
      $(function(){
        $("#c3").click(function(){
          $("#d3").toggle();
        });
        });
      $(function(){
        $("#c4").click(function(){
            $("#d4").toggle();
          });
          });
      $(function(){
         $("#c5").click(function(){
          $("#d5").toggle();
            });
            });
      $(function(){
          $("#c6").click(function(){
          $("#d6").toggle();
              });
              });
      $(function(){
          $("#c7").click(function(){
          $("#d7").toggle();
                });
                });
      $(function(){
          $("#c8").click(function(){
          $("#d8").toggle();
                  });
                  });  
  
  }
  
  toggleOpen = id => {
    if (!this.state.opened.includes(id)) {
      this.setState({ opened: [...this.state.opened, id] });
    } else {
      this.setState({ opened: [...this.state.opened.filter(i => i !== id)] });
    }
  };

  render() {
    return (
    
            <div className="sidebar">
              <div id="sidebar1">
                <div className="sidebar-elementhead"><Link className="sidebar-link" to="/">Home</Link></div>
                {/*<div className="sidebar-sectionName">
    Products</div>*/}
                <div className="oneTab">
                <div className="sidebar-element" id="c1"> <i class="fa fa-bar-chart" /> <Link className="sidebar-link" to="/">Dashboard</Link><i className="fa fa-angle-right " /></div>
                  <div className="sidebar-subelement" id="d1"><i class="fa fa-envelope" />View<i className="fa fa-angle-right " /></div>
                </div>
                {
       getPrivilegeByName('Products').canView ?   <div className="oneTab">
                  <div className="sidebar-element" id="c2">
                    <i class="fa fa-envelope" />
                    Products 
                    <i className="fa fa-angle-down " />
                  </div>
                  <div className="sidebar-subelement" id="d2">
                    <div className="sub-tabs">
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/products/product-requests"}>
                   
                    Product Requests
                    <i className="fa fa-angle-right " />
                    </Link>
                    </div>
                    <div className="sub-tabs">
                    <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/products/queries-sent"}>
                  
                    Queries Sent
                    <i className="fa fa-angle-right " />
                    </Link>
                    </div>
                  </div>
                </div> : ''}
                {
       getPrivilegeByName('Consultings').canView ?  <div className="oneTab">
                  <div className="sidebar-element" id="c3">
                  <i class="fa fa-envelope" />
                  
                    Consulting 
                    <i className="fa fa-angle-down " />
                 
                  </div>
                  <div className="sidebar-subelement" id="d3">
                  <div className="sub-tabs">
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/consulting/proposals-requested"}>
                    
                    Proposals Request
                    <i className="fa fa-angle-right " />
                    </Link>
                  </div>
                  <div className="sub-tabs">
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/consulting/queries-sent"}>
                   
                    Queries Sent
                    <i className="fa fa-angle-right " />
                    </Link>
                  </div>
                  </div>
                </div> : '' }
                {
       getPrivilegeByName('Docs').canView ?
        <div className="oneTab">
                  <div className="sidebar-element" id="c4">
                    <i class="fa fa-envelope" />
                    Docs <i className="fa fa-angle-down " />
                  </div>
                  
                  <div className="sidebar-subelement" id="d4">
                  <div className="sub-tabs">
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/docs/vetting-requests"}>
                  
                     Vetting Queries                   
                      <i className="fa fa-angle-right " />
                    </Link>
                    </div>
                 
                  <div className="sub-tabs">
                  
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/docs/tailoring-requests"}>
                   
                     Tailored Queries
                    <i className="fa fa-angle-right " />
                    </Link>
                  </div>
                  <div className="sub-tabs">
                  
                 
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/docs/instant-downloads"}>
                   
                    Instant Download Queries
                    <i className="fa fa-angle-right " />
                    </Link>
                  </div>
                  <div className="sub-tabs">
                 
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/docs/queries-sent"}>
                  
                    Queries Sent
                    <i className="fa fa-angle-right " />
                    </Link>
                  </div>
               
                </div>
                </div> : ''}
              
                {
       getPrivilegeByName('Products').canView &&
       getPrivilegeByName('Consultings').canView &&
       getPrivilegeByName('Docs').canView  ?  <div className="oneTab">
                  <div className="sidebar-element" id="c5">
                 
                    <i class="fa fa-envelope" />
                    All Queries
                    <i className="fa fa-angle-down " />
                   
                  </div>
                  <div className="sidebar-subelement" id="d5">
                  <div className="sub-tabs">
                  <Link className="sidebar-link" to={"/organisations/"+sessionStorage.orgName+"/services/products/all-queries-sent"}>
                  
                    Queries Made
                    <i className="fa fa-angle-right " />
                    </Link>
                    </div>
                  </div>
                </div> : ''}
              
                
     
              
              </div>
            </div>
         
    );
  }
}
